import { classes } from '@/uiPrimitives/base/classes.helpers';
import {
	subgridRowsBase,
	subgridRowsSprinkles,
	supergridRowsBase,
	supergridRowsSprinkles,
} from './subgridRows.css';
import { RequiredProps } from '@/globals/helpers/typescript.helpers';

/**
 * The parent of the subgrid. Use this to define the rows for the subgrid.
 */
export const supergridRows = (
	props: RequiredProps<
		Parameters<typeof supergridRowsSprinkles>[0],
		'rowCount'
	>,
) => {
	return classes(supergridRowsBase, supergridRowsSprinkles(props));
};

/**
 * To create CSS subgrid rows
 *
 * Use this when children need to align their content to each other
 *
 * Note: normal `pageGrid`’s can be nested. This class is only for when you need CSS subgrid.
 */
export const subgridRows = (
	props: Parameters<typeof subgridRowsSprinkles>[0],
) => {
	return classes(subgridRowsBase, subgridRowsSprinkles(props));
};
